/**
 * Usuwa `?panel=true` z URL bez przejścia Next Routera (bez routeChangeStart/Complete).
 * Używamy zamiast router.replace({}, { shallow }), bo shallow nadal wywołuje eventy trasowania,
 * przez co zamykane może być megamenu / panel usera zaraz po otwarciu.
 */
export const stripPanelTrueFromBrowserUrl = (): void => {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  if (url.searchParams.get('panel') !== 'true') return;
  url.searchParams.delete('panel');
  const qs = url.searchParams.toString();
  const pathnameWithSearchAndHash = `${url.pathname}${qs ? `?${qs}` : ''}${url.hash}`;
  window.history.replaceState(window.history.state, '', pathnameWithSearchAndHash);
};